<div class="fixed-black-background">
    <ng-content></ng-content>
</div>
